// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content($organization_ids: [numeric!]!) {
  vaxiom_application_properties(
    where: {
      organization_id: { _in: $organization_ids }
      _or: [
        { message_key: { _eq: "audax.ceph.enabled" } }
        { message_key: { _eq: "admin.patient.videos.enabled" } }
      ]
    }
    order_by: { organization_id: desc }
  ) {
    id: message_key
    value: message_value
  }
  itero_connections: apps_connections(where: { name: { _eq: "itero" } }) {
    id
  }
}

`